import React, { Component } from 'react';

import UserRanking from './UserRanking';
import UsersScoreboard from './UsersScoreboard';
import RootCauseGraph from '../RootCauseGraph';
import RightColumn from '../../../components/RightColumn';
import ActivityFeed from '../../../components/ActivityFeed';
import PieChart from '../PieChart/';
import PanelWrapper from './PanelWrapper';

class RightPanelColumn extends Component {
  dropdownItemMap = [
    {
      title: 'User Ranking',
      key: 'UserRanking',
    },
    {
      title: 'User Scoreboard',
      key: 'UserScoreboard',
    },
    {
      title: 'Activity Feed',
      key: 'ActivityFeed',
    },
    {
      title: 'Team Scoreboard',
      key: 'TeamScoreboard',
    },
    {
      title: 'Root Cause Graph',
      key: 'RootCauseGraph',
    },
    //{
    //  title: 'Issues Pie Demo',
    //  key: 'PieChart',
    //},
  ];

  mapPanelToComponent = (position, i, enableDashboardLayout, name) => {
    const {
      project,
      user,
      users,
      projectUsers,
      panelComponents,
      setPanel,
    } = this.props;

    const currentPanel = position ? panelComponents.get(position) : name;

    switch (currentPanel) {
      case 'UserRanking':
        return (
          <PanelWrapper
            panelClassName="user-ranking"
            position={position}
            enableDashboardLayout={enableDashboardLayout}
            callback={setPanel}
            dropdownItemMap={this.dropdownItemMap}
            title="Your Performance"
          >
            <UserRanking project={project} user={user} />
          </PanelWrapper>
        );
      case 'PieChart':
        return (
          <PanelWrapper
            panelClassName="pie-chart"
            position={position}
            enableDashboardLayout={enableDashboardLayout}
            callback={setPanel}
            dropdownItemMap={this.dropdownItemMap}
            title="Issues By Company"
          >
            <PieChart type="issues" projectId={project.get('id')} />
          </PanelWrapper>
        );
      case 'RootCauseGraph':
        return (
          <PanelWrapper
            panelClassName="root-cause-graph"
            position={position}
            enableDashboardLayout={enableDashboardLayout}
            callback={setPanel}
            dropdownItemMap={this.dropdownItemMap}
            title="Root Cause"
          >
            <RootCauseGraph params={{ projectId: project.get('id') }} pie />
          </PanelWrapper>
        );
      case 'UserScoreboard':
        return (
          <PanelWrapper
            panelClassName="user-scoreboard"
            position={position}
            enableDashboardLayout={enableDashboardLayout}
            callback={setPanel}
            dropdownItemMap={this.dropdownItemMap}
            title="User Scoreboard"
          >
            <UsersScoreboard
              scoreboard
              project={project}
              user={user}
              users={users}
              projectUsers={projectUsers}
            />
          </PanelWrapper>
        );
      case 'TeamScoreboard':
        return (
          <PanelWrapper
            panelClassName="team-scoreboard"
            position={position}
            enableDashboardLayout={enableDashboardLayout}
            callback={setPanel}
            dropdownItemMap={this.dropdownItemMap}
            title="Team Scoreboard"
          >
            <UsersScoreboard
              project={project}
              user={user}
              users={users}
              projectUsers={projectUsers}
            />
          </PanelWrapper>
        );
      case 'ActivityFeed':
        return (
          <PanelWrapper
            panelClassName="panel-activity-feed"
            position={position}
            enableDashboardLayout={enableDashboardLayout}
            callback={setPanel}
            dropdownItemMap={this.dropdownItemMap}
            title="Activity Feed"
          >
            <ActivityFeed
              projectId={project.get('id')}
              currentUser={user}
              loadAll={true}
              dashboard
              style={{
                overflowY: 'auto',
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
              }}
            />
          </PanelWrapper>
        );
      default:
        return (
          <PanelWrapper
            panelClassName="panel-error"
            position={position}
            callback={setPanel}
            dropdownItemMap={this.dropdownItemMap}
            title="Error"
          />
        );
    }
  };

  render() {
    const {
      currentElement,
      setCurrentElement,
      enableDashboardLayout,
      product,
    } = this.props;
    if (currentElement.size > 0) {
      const entity = currentElement;
      const callback = setCurrentElement;
      const entityType = 'element';

      return (
        <div className="dashboard-right-panel-open">
          <RightColumn
            entity={entity}
            entityType={entityType}
            callback={callback}
            flexOverride
            dashboard
          />
        </div>
      );
    }

    switch (product) {
      case 'issues':
        return (
          <div className="dashboard-right-panel-wrapper">
            <div className="dashboard-right-panel-50">
              {this.mapPanelToComponent(null, 0, false, 'PieChart')}
            </div>
            <div className="dashboard-right-panel-50">
              {this.mapPanelToComponent(null, 0, false, 'ActivityFeed')}
            </div>
          </div>
        );
      default:
        return (
          <div className="dashboard-right-panel-wrapper">
            <div className="dashboard-right-panel-40">
              {this.mapPanelToComponent('top', 0, enableDashboardLayout)}
            </div>
            <div className="dashboard-right-panel-40">
              {this.mapPanelToComponent('middle', 1, enableDashboardLayout)}
            </div>
            <div className="dashboard-right-panel">
              {this.mapPanelToComponent('bottom', 2, enableDashboardLayout)}
            </div>
          </div>
        );
    }
  }
}

export default RightPanelColumn;



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/RightPanelColumn.js